import { useReducer, useEffect, useState } from "react";
import { Form, Row, Col, Button, Table, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";

const initialState = {
  // global for order
  owner_id: 0,
  customer_name: "",
  date_of_delivery: "",
  customer_phone: "",

  // for adding service
  order_id: 0,
  serviceData: [],
  addonData: [],
  category: "mens",
  garment: "",
  service: "",
  addonItem: "",
  nos: 0,
  price: 0,
  subTotal: 0,
  total: 0,
  advance: 0,
  balance: 0,

  // extra fields
  home_delivery: null,
  comment: "",

  // show success
  add: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "fetch-addons":
      return { ...state, addonData: action.payload };

    case "addon-item":
      return {
        ...state,
        addonItem: action.payload.name,
        price: action.payload.price,
        garment: action.payload.name,
        service: "addon",
        subTotal: state.nos ? action.payload.price * state.nos : 0,
      };
    case "ownerid":
      return { ...state, owner_id: action.payload };

    case "neworderid":
      return { ...state, order_id: action.payload };

    case "fetch-load":
      return { ...state, serviceData: action.payload };

    case "custname":
      return { ...state, customer_name: action.payload };

    case "custname_phone":
      return { ...state, customer_phone: action.payload };

    case "home_delivery":
      return { ...state, home_delivery: action.payload };

    case "dateOfDel":
      return { ...state, date_of_delivery: action.payload };

    case "customer_id":
      return { ...state, customer_id: action.payload };

    case "category":
      return {
        ...state,
        category: action.payload,
        garment: "",
        service: "",
        addonItem: "",
        price: 0,
        nos: 0,
        subTotal: 0,
      };

    case "garment":
      return {
        ...state,
        garment: action.payload,
        service: "",
        addonItem: "",
        price: 0,
        nos: 0,
        subTotal: 0,
      };

    case "service-price":
      return {
        ...state,
        service: action.payload.service,
        price: action.payload.price,
        subTotal: state.nos ? action.payload.price * state.nos : 0,
      };

    case "comment":
      return {
        ...state,
        comment: action.payload,
      };

    case "nos-subtotal":
      return {
        ...state,
        nos: action.payload.nos,
        subTotal: action.payload.subTotal,
      };

    case "totalntotalnos":
      return {
        ...state,
        total: action.payload.total,
        total_nos: action.payload.ts,
      };

    case "advance":
      return {
        ...state,
        advance: action.payload,
      };

    case "balance":
      return { ...state, balance: state.total - state.advance };

    case "success-add":
      return { ...state, add: true };

    case "reset":
      return {
        ...state,
        garment: "",
        subTotal: 0,
        price: 0,
        nos: 0,
        service: "",
      };

    default:
      return state;
  }
};

const AddNewService = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [details, setDetails] = useState([]);

  const {
    order_id,
    owner_id,
    serviceData,
    addonData,
    addonItem,
    customer_name,
    customer_phone,
    category,
    garment,
    service,
    nos,
    price,
    subTotal,
    total,
    total_nos,
    balance,
    advance,
    date_of_delivery,
    add,
    home_delivery,
    comment,
  } = state;

  const backendURI = process.env.REACT_APP_BK_URL;

  useEffect(() => {
    const ownerid = JSON.parse(localStorage.getItem("id"));
    dispatch({ type: "ownerid", payload: ownerid });
  }, []);

  useEffect(() => {
    dispatch({ type: "balance" });
  }, [advance, total]);

  useEffect(() => {
    let t = 0;
    let tnos = 0;

    details.forEach((item) => {
      if (typeof item === "object") {
        t = t + Number(item.subTotal || 0);
        tnos = tnos + Number(item.nos || 0);
      }
    });

    dispatch({
      type: "totalntotalnos",
      payload: {
        total: t,
        ts: tnos,
      },
    });
  }, [details]);

  useEffect(() => {
    fetch(`${backendURI}/api/addons`)
      .then((res) => res.json())
      .then((json) => {
        dispatch({
          type: "fetch-addons",
          payload: Array.isArray(json) ? json : [],
        });
      })
      .catch((err) => {
        console.error("Failed to fetch addons:", err);
        dispatch({ type: "fetch-addons", payload: [] });
      });
  }, [backendURI]);

  useEffect(() => {
    if (!category || category === "addons") {
      dispatch({ type: "fetch-load", payload: [] });
      return;
    }

    fetch(`${backendURI}/api/${category}`)
      .then((res) => res.json())
      .then((json) => {
        dispatch({
          type: "fetch-load",
          payload: Array.isArray(json) ? json : [],
        });
      })
      .catch((err) => {
        console.error("Failed to fetch service data:", err);
        dispatch({ type: "fetch-load", payload: [] });
      });
  }, [category, backendURI]);

  useEffect(() => {
    if (!order_id) return;

    const detailsWithOrderId = details.map((item) => ({
      ...item,
      order_id,
    }));

    detailsWithOrderId.forEach(postDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_id]);

  const selectedGarmentData = serviceData.find(
    (item) => item.garment === garment
  );

  const availableServices = selectedGarmentData
    ? Object.keys(selectedGarmentData).filter(
      (key) =>
        key !== "id" &&
        key !== "garment" &&
        selectedGarmentData[key] !== null &&
        selectedGarmentData[key] !== undefined
    )
    : [];

  const postDetails = (item) => {
    fetch(`${backendURI}/api/details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(item),
    });
  };

  const setPrice = (e) => {
    const selectedService = e.target.value;

    if (!selectedGarmentData || !selectedService) {
      dispatch({
        type: "service-price",
        payload: {
          service: "",
          price: 0,
        },
      });
      return;
    }

    dispatch({
      type: "service-price",
      payload: {
        service: selectedService,
        price: Number(selectedGarmentData[selectedService] || 0),
      },
    });
  };

  const setSubTotal = (e) => {
    const selectedNos = Number(e.target.value || 0);

    dispatch({
      type: "nos-subtotal",
      payload: {
        nos: selectedNos,
        subTotal: Number(price || 0) * selectedNos,
      },
    });
  };

  const onAdd = () => {
    if (category === "addons") {
      if (!addonItem || !nos || !price) {
        alert("Please choose item and quantity.");
        return;
      }

      const addonDetails = {
        category: "addons",
        garment: addonItem,
        service: "addon",
        nos,
        price,
        subTotal,
        comment,
      };

      setDetails((prev) => [...prev, addonDetails]);

      dispatch({
        type: "reset",
      });

      return;
    }

    if (!category || !garment || !service || !nos || !price) {
      alert("Please choose category, garment, service, and quantity.");
      return;
    }

    const allDetails = {
      category,
      garment,
      service,
      nos,
      price,
      subTotal,
      comment,
    };

    setDetails((prev) => [...prev, allDetails]);

    dispatch({
      type: "reset",
    });
  };

  const postOrder = () => {
    if (!details.length) {
      alert("Please add at least one service before adding the order.");
      return;
    }

    fetch(`${backendURI}/api/orders`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify({
        owner_id: owner_id,
        customer_name: customer_name,
        nos: total_nos,
        date_of_delivery: date_of_delivery,
        total: total,
        advance: advance,
        balence: balance,
        home_delivery: home_delivery,
        customer_phone: customer_phone,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json[0].customer_name) {
          dispatch({ type: "neworderid", payload: json[0].id });
          dispatch({ type: "success-add" });
        }
      })
      .catch((err) => {
        console.error("Failed to add order:", err);
      });
  };

  const custFind = (e) => {
    e.preventDefault();

    setTimeout(() => {
      fetch(`${backendURI}/api/users/findone/${e.target.value}`)
        .then((res) => res.json())
        .then((json) => {
          try {
            dispatch({ type: "custname", payload: json[0].name });
            dispatch({ type: "custname_phone", payload: json[0].phone });
          } catch {
            dispatch({
              type: "custname",
              payload: "No customer with this phone found.",
            });
            dispatch({ type: "custname_phone", payload: "" });
          }
        })
        .catch((err) => {
          console.error("Failed to find customer:", err);
        });
    }, 1100);
  };

  const handleHd = (e) => {
    if (e.target.checked === true) {
      dispatch({ type: "home_delivery", payload: true });
    } else {
      dispatch({ type: "home_delivery", payload: null });
    }
  };

  const handleDelete = (index) => {
    const newDetails = details.filter((_, i) => i !== index);
    setDetails(newDetails);
  };

  return (
    <div>
      {add === false ? (
        <>
          <Form>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Customer Phone/Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      custFind(e);
                    }}
                  />
                </Form.Group>
              </Col>

              <Col>
                <h4 className="mx-4">
                  Customer Name: <br />
                  <p className="text-success">{customer_name}</p>
                </h4>
              </Col>

              <Col>
                <Form.Check
                  value="home_delivery"
                  onChange={(e) => {
                    handleHd(e);
                  }}
                  label="Home Delivery"
                />
              </Col>
            </Row>
          </Form>

          <br />
          <hr />
          <br />

          <h3 className="text-center">Add Service</h3>

          <br />

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Category</Form.Label>
                <Form.Select
                  value={category}
                  onChange={(e) =>
                    dispatch({ type: "category", payload: e.target.value })
                  }
                >
                  <option value="">Choose a Category</option>
                  <option value="mens">Mens</option>
                  <option value="women">Women</option>
                  <option value="kids">Kids</option>
                  <option value="family">Family</option>
                  <option value="home_decor">Home Decor</option>
                  <option value="addons">Add-ons / Packaging</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {category === "addons" ? (
              <>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Item</Form.Label>
                    <Form.Select
                      value={addonItem}
                      onChange={(e) => {
                        const selectedAddon = addonData.find(
                          (item) => item.name === e.target.value
                        );

                        if (!selectedAddon) return;

                        dispatch({
                          type: "addon-item",
                          payload: {
                            name: selectedAddon.name,
                            price: Number(selectedAddon.price),
                          },
                        });
                      }}
                    >
                      <option value="">Choose Item</option>
                      {addonData.map((item) => (
                        <option key={item.id} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Type</Form.Label>
                    <Form.Control readOnly value="Add-on" />
                  </Form.Group>
                </Col>
              </>
            ) : (
              <>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Garment</Form.Label>
                    <Form.Select
                      value={garment}
                      onChange={(e) => {
                        dispatch({ type: "garment", payload: e.target.value });
                      }}
                    >
                      <option value="">Choose Garment</option>
                      {serviceData.map((item, i) => (
                        <option key={i} value={item.garment}>
                          {item.garment}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Service</Form.Label>
                    <Form.Select
                      value={service}
                      onChange={(e) => {
                        setPrice(e);
                      }}
                      disabled={!garment}
                    >
                      <option value="">Choose a Service</option>
                      {availableServices.map((serviceName) => (
                        <option key={serviceName} value={serviceName}>
                          {serviceName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </>
            )}

            <Col>
              <Form.Group>
                <Form.Label>Nos</Form.Label>
                <Form.Control
                  value={nos}
                  onChange={(e) => {
                    setSubTotal(e);
                  }}
                  type="number"
                  min="0"
                  placeholder=""
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group>
                <Form.Label>Rate</Form.Label>
                <Form.Control
                  readOnly
                  type="text"
                  value={`Rs:${price}/piece`}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group>
                <Form.Label>Subtotal</Form.Label>
                <Form.Control readOnly type="text" value={subTotal} />
              </Form.Group>
            </Col>

            <Col>
              <Button
                className="mt-4"
                onClick={onAdd}
                variant="outline-success"
                size="lg"
              >
                Add
              </Button>
            </Col>
          </Row>

          <Row>
            <InputGroup>
              <InputGroup.Text>Comment</InputGroup.Text>
              <Form.Control
                value={comment}
                onChange={(e) => {
                  dispatch({ type: "comment", payload: e.target.value });
                }}
                as="textarea"
                aria-label="Comment"
                size="xs"
              />
            </InputGroup>
          </Row>

          <br />

          <h3 className="text-center">Order Details</h3>

          <br />

          <Table striped bordered hover>
            <thead>
              <tr>
                <th> </th>
                <th>Category</th>
                <th>Garment</th>
                <th>Service</th>
                <th>Price</th>
                <th>Nos</th>
                <th>SubTotal</th>
                <th>Comment</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {details.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{item.category}</td>
                    <td>{item.garment}</td>
                    <td>{item.service}</td>
                    <td>{item.price}</td>
                    <td>{item.nos}</td>
                    <td>{item.subTotal}</td>
                    <td>{item.comment}</td>
                    <td>
                      <Button variant="danger" onClick={() => handleDelete(i)}>
                        Del
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <br />
          <hr />

          <Row>
            <Col>
              <h4 className="text-center">Total No Of Garments</h4>
            </Col>
            <Col>
              <h4 className="text-center">{total_nos}</h4>
            </Col>
          </Row>

          <Row>
            <Col>
              <h4 className="text-center">Total</h4>
            </Col>
            <Col>
              <h4 className="text-center">₹{total}/-</h4>
            </Col>
          </Row>

          <Row>
            <Col>
              <h4 className="text-center">Advance</h4>
            </Col>

            <Col>
              <Form.Control
                className="text-center fs-4 fw-bold"
                type="number"
                value={advance}
                onChange={(e) => {
                  dispatch({ type: "advance", payload: Number(e.target.value) });
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <h4 className="text-center">Balance</h4>
            </Col>
            <Col>
              <h4 className="text-center">₹{balance}/-</h4>
            </Col>
          </Row>

          <br />

          <Row>
            <Button size="lg" variant="success" onClick={postOrder}>
              Add Order
            </Button>
          </Row>
        </>
      ) : (
        <>
          <h3 className="text-success">The order has been added.</h3>
          <Link to="/admindash">&#8592; Go to admin dashboard.</Link>
        </>
      )}
    </div>
  );
};

export default AddNewService;
